import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class NoScoresDisplayEvent extends BaseAnalyticsEvent {
  entityId: String;
  entityType: String;
  sportTypeId: Number;
  filter: String;

  constructor(params) {
    super('', 'display', 'no-scores');

    this.entityId = params.entityId;
    this.entityType = params.entityType;
    this.sportTypeId = params.sportTypeId;
    this.filter = params.filter;
  }

  get properties() {
    const properties = super.properties;

    properties.entityId = this.entityId;
    properties.entityType = this.entityType;
    properties.sportTypeId = this.sportTypeId;
    properties.filter = this.filter;

    return properties;
  }
}